<template>
    <div>
        <div class="item">
            <label class="check_wrap">
                <input type="checkbox" v-model="state.isSelected" @click="action_SelectItem">
                <span class="checkmark"></span>
                <span class="color_square" :style="backgroudColor"></span>
                <span class="txt ellipsis">{{ stateString }}</span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    props: { 
        state: Object,
        index: Number,
        palette: Array
    },
    mounted() {
        
    },
    computed: {
        stateString: function() {
            return this.state.title ?? '-'
        },
        backgroudColor: function() {
            return 'background-color:' + this.palette[this.state.paletteIndex]
        }
    },
    watch: {

    },
    methods: {
        action_SelectItem() {
            this.$emit('action_SelectItem', this.index)
        }
    }
}
</script>